// Saisie d'un nouveau mot de passe avec confirmation. Mêmes règles que l'API (auth.py) :
// au moins 12 caractères, au plus 72 octets, sans autre contrainte de complexité.
export const PASSWORD_MIN_LENGTH = 12;
const PASSWORD_MAX_BYTES = 72;

export function passwordError(password, confirmation) {
    if (password.length < PASSWORD_MIN_LENGTH) return `Le mot de passe doit faire au moins ${PASSWORD_MIN_LENGTH} caractères.`;
    if (new TextEncoder().encode(password).length > PASSWORD_MAX_BYTES) return 'Le mot de passe est trop long.';
    if (password !== confirmation) return 'Les deux saisies diffèrent.';
    return null;
}

export default function PasswordFields({ password, confirmation, onPasswordChange, onConfirmationChange, autoFocus = true }) {
    return (
        <>
            <div className="auth-field">
                <label htmlFor="new-password">Nouveau mot de passe</label>
                <input
                    id="new-password" type="password" autoComplete="new-password" required autoFocus={autoFocus}
                    value={password} onChange={(e) => onPasswordChange(e.target.value)}
                />
                <span className="auth-hint">Au moins {PASSWORD_MIN_LENGTH} caractères. Une phrase facile à retenir fait un bon mot de passe.</span>
            </div>
            <div className="auth-field">
                <label htmlFor="confirm-password">Confirmer</label>
                <input
                    id="confirm-password" type="password" autoComplete="new-password" required
                    value={confirmation} onChange={(e) => onConfirmationChange(e.target.value)}
                />
            </div>
        </>
    );
}
